<template>
  <div>
    <van-nav-bar
      title="追加保证金"
      left-text=""
      left-arrow
      @click-left="$router.push('/account_details')"
    />
    <van-form>
      <van-cell title="合约编号">
        <template #default>
          <span>{{order}}</span>
        </template>
      </van-cell>
      <van-row>
          <van-col span="24" class="divideSection"> 
              <span>当前总账户余额 ：{{cash}}元</span><br>
              <span>当前子账户余额 ：{{balance}}元</span><br>
              <span>当前亏损警戒线(亏损比）:{{warning}}元 <span class="percentageColor">(-{{warning_line_ratio}})</span></span><br>
              <span>当前亏损平仓线(亏损比）:{{close}}元 <span class="percentageColor">(-{{close_line_ratio}})</span></span>
          </van-col>
      </van-row>
      <!-- <van-cell title="当前余额">
        <template #default>
          <span>{{total}}元</span>
        </template>
      </van-cell> -->
      <van-field
        v-model="addBondMoney"
        type="digit"
        placeholder="请输入追加金额 最低100元起"
        input-align="right"
      ><template #label>
       <div style="width:100px;">追加保证金</div> 
      </template>
      </van-field>
      <van-row>
          <van-col span="24" class="divideSectionBottom">
              <span>追加后总账户余额 ：{{availableCash}}元</span><br>
              <span>追加后子账户余额 :{{after_total}}元</span><br>
              <span>追加后亏损警戒线（亏损比）:{{warning}}元 <span class="percentageColor">(-{{warning_line_ratio_after}}%)</span></span><br>
              <span>追加后亏损平仓线（亏损比）:{{close}}元 <span class="percentageColor">(-{{close_line_ratio_after}}%)</span></span>
          </van-col>
      </van-row>
      <!-- <van-row style="padding: 10px"
        ><van-col span="8" style="text-align: right"
          ><van-icon
            name="warning"
            size="25px"
            color="red"
            style="padding-right: 10px" /></van-col
        ><van-col span="16" style="color: #969799; font-size: 14px">
          最低追加金额100元</van-col
        >
      </van-row> -->
      <van-button size="small" type="danger" block @click="operationBondAdd()">立即追加</van-button>
    </van-form>
    <!-- <van-overlay :show="loadingMask">
      <div class="wrapper">
        <div class="block">
          <van-loading color="#ee0a24"  />
        </div>
      </div>
    </van-overlay> -->
    <CommonLoading ref="commonLoader"></CommonLoading>
  </div>
</template>

<script>
import CommonLoading from "./CommonLoading";
export default {
  name: "IncreaseCapitalInfo",
  components: {
    CommonLoading,
  },
  data() {
    return {
      loadingMask: false,
      availableCash:"",
      cash:"0.00",
      increase_bond:"",
      close_ratio:"",
      warning_ratio:"",
      after_total:"0.00",
      inputAmount:"",
      warning:"0.00",
      close:"0.00",
      warning_line_ratio: "0.00",
      close_line_ratio: "0.00", 
      cid: sessionStorage.getItem("cid"),
      order:0,
      total:0,
      balance: "0.00", //余额
      minBondAdd: "", //最低追保证金金额
      addBondMoney: "", //追加保证金 金额
      warning_line_ratio_after:"",
      close_line_ratio_after:"",
      bond:0,
      multiple:0,

    };
  },
  watch:{
    addBondMoney: function (value){
      if(value){
        //capital account balance after add values
        let totalAfter = (parseFloat(value) + parseFloat(this.balance));
        this.after_total = parseFloat(totalAfter).toFixed(2);
        
        //main balance after add values
        let cash = (parseFloat(this.cash) - parseFloat(value));
        this.availableCash = parseFloat(cash).toFixed(2);

        //warning ratio after add values
        let afterWarningRatio = (((parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value))-(parseFloat(this.bond)*parseFloat(this.warning_ratio)))/(parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value)))*100;
        this.warning_line_ratio_after = parseFloat(afterWarningRatio).toFixed(2);

        //closing ratio after add values
        let afterClosingRatio = (((parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value))-(parseFloat(this.bond)*parseFloat(this.close_ratio)))/(parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value)))*100;
        this.close_line_ratio_after = parseFloat(afterClosingRatio).toFixed(2);
        
      }else{
        this.availableCash = parseFloat(this.cash).toFixed(2);
        this.after_total = this.balance;
        this.warning_line_ratio_after = this.warning_line_ratio.replace(/[^0-9.-]/g, '');
        this.close_line_ratio_after = this.close_line_ratio.replace(/[^0-9.-]/g, '');
      }
      
    }
  },
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    //追加履约金 - 显示
    showBondAdd() {
        let that = this;
        that.$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "increase_bond_info",
            token: sessionStorage.getItem("token"),
            cid: that.cid
          }
        })
          .then(function (res) {
            if (res.data.code == 1) {
              that.balance = res.data.data.total;
              that.minBondAdd = res.data.data.min_bond;
              that.close = res.data.data.close;
              that.warning = res.data.data.warning;
              that.warning_line_ratio = res.data.data.warning_line_ratio;
              that.close_line_ratio = res.data.data.close_line_ratio;
              that.warning_ratio = res.data.data.warning_ratio;
              that.close_ratio = res.data.data.close_ratio;
              that.bond = res.data.data.bond;
              that.multiple = res.data.data.multiple;
              that.increase_bond = res.data.data.increase_bond;
              that.cash = res.data.data.cash;
              
              that.availableCash = that.cash;
              that.after_total = that.balance;
              that.warning_line_ratio_after = that.warning_line_ratio.replace(/[^0-9.-]/g, '');
              that.close_line_ratio_after = that.close_line_ratio.replace(/[^0-9.-]/g, '');

            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(res.data.msg);
            }
          });
      },
      //追加履约金 - 操作
      operationBondAdd() {
        let that = this;
        if (that.addBondMoney == "") {
          that.$toast.fail("请输入追加金额");
        } else {
          // that.loadingMask = true;
          that.$refs.commonLoader.showCommonLoadigIcon();
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "increase_bond_operate",
              token: sessionStorage.getItem("token"),
              cid: that.cid,
              number: that.addBondMoney
            }
          })
            .then(function (res) {
              that.$refs.commonLoader.hideCommonLoadigIcon();
              if (res.data.code == 1) {
                that.addBondMoney = "";
                that.$toast({
                  message: res.data.msg,
                  type: "success",
                  duration: 1000,
                  onClose:function () {
                  that.$router.push({
                    path: "/account_details"
                  });
                }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            }).finally(() => {
              // that.loadingMask = false;
              that.$refs.commonLoader.hideCommonLoadigIcon();
            });
        }
      },
  },
  mounted: function () {
    this.isLogin();
    this.showBondAdd();
    this.total = this.$route.params.total;
    this.order = this.$route.params.order;
  },
};
</script>

<style scoped>
.divideSection {
  height: 90px;
  background: #f1f1f1;
  border-top: 1px solid #f2f3f5;
  border-bottom: 1px solid #f2f3f5;
  padding: 5px;
  padding-left: 16px;
  font-size: 14px;
}

.divideSectionBottom{
  background: #f1f1f1;
  border-top: 1px solid #f2f3f5;
  border-bottom: 1px solid #f2f3f5;
  padding: 5px;
  padding-left: 16px;
  font-size: 14px;
}
.percentageColor{
  color:red;
}
</style>



// WEBPACK FOOTER //
// src/components/IncreaseBondInfo.vue